var map = {
	"./00_base_1210mk2_VG+.png": "fa4a",
	"./01_body_1200mk2_VG+.png": "064f",
	"./01_body_1200mk5_nasty.png": "00ef5",
	"./01_body_1210_rough.png": "9872",
	"./02_tone_1200.png": "86cf",
	"./02_tone_1210.png": "2793",
	"./03_slip_felt_technics1.png": "ad83",
	"./03_slip_rubber.png": "aeb1",
	"./04_stylii_M447.png": "de62",
	"./04_stylii_conc_silver.png": "5eb5",
	"./05_feet_Isonoe_blk.png": "4020",
	"./05_feet_Isonoe_silver.png": "0f9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c7b1";